<template>
  <div class="sort-by-col-container">
    <span>
      <a href="#" @click.prevent="toggleSort(upId)">
        <img :src="upArrowSrc">
      </a>
      <a href="#" @click.prevent="toggleSort(downId)">
        <img :src="downArrowSrc">
      </a>
    </span>
    <slot></slot>
  </div>
</template>

<script>
  import {misc} from '@/mixins'

  export default {
    name: 'SortByCol',
    mixins: [misc],
    props: {
      group: {
        type: String,
        required: true
      },
      col: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        upId: this.generateUniqueString(),
        downId: this.generateUniqueString(),
        selectedId: '',
        imgPath: '/static/img/competitors'
      }
    },
    computed: {
      upArrowSrc () {
        return `${this.imgPath}/arrow_up${this.upId === this.selectedId ? '_selected' : ''}.svg`
      },
      downArrowSrc () {
        return `${this.imgPath}/arrow_down${this.downId === this.selectedId ? '_selected' : ''}.svg`
      }
    },
    created () {
      window.events.$on('sort-changed', data => {
        if (this.group === data.group) {
          this.selectedId = data.id
        }
      })
    },
    destroyed () {
      window.events.$off('sort-changed')
    },
    methods: {
      toggleSort (id) {
        if (this.selectedId !== id) {
          window.events.$emit('sort-changed', {
            group: this.group,
            id: id,
            col: this.col,
            order: (id === this.upId) ? 'asc' : 'desc'
          })
        }
      }
    }
  }
</script>

<style scoped>
  .sort-by-col-container {
    display: flex;
    align-items: center;
  }

  .sort-by-col-container > span {
    display: flex;
    flex-direction: column;
    margin-right: 8px
  }

  .sort-by-col-container > span > a:first-child {
    height: 8px
  }

  .sort-by-col-container > span > a:last-child {
    height: 5px
  }

  .sort-by-col-container > span img {
    vertical-align: text-top
  }
</style>



// WEBPACK FOOTER //
// src/components/SortByCol.vue